/**
 * RoleType — Enum tên role người dùng
 * CreatedBy: dbhuan (16/06/2026)
 */
export const RoleType = {
  /** Quản trị merchant */
  MERCHANT_ADMIN: "MerchantAdmin",
  /** Thiết lập hệ thống */
  SETTING: "Setting",
};

/** Các role được phép truy cập màn hình Settings */
export const SETTINGS_ROLES = [RoleType.MERCHANT_ADMIN, RoleType.SETTING];
